import React from 'react'
import {View, Text} from "@react-pdf/renderer";

const TableHeader = () => {
  return (
    <View
    style={{
        flexDirection: "row",
        padding: "0px 10px"
    }}
>
    
    <View
        style={{
            width:"100%",
            flexDirection: "row"
        }}
    >
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "8%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Item
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Critical
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Major
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "24%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Minor
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "12%",
            borderWidth: "1px",
            borderColor: "#000",
            borderRightWidth: "0px",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Notes
            </Text>
        </View>
        <View
        style={{
            backgroundColor: "#666666",
            padding: "1px",
            width: "8%",
            borderWidth: "1px",
            borderColor: "#000",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <Text
                style={{
                    fontSize: "7px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Pic
            </Text>
        </View>
    </View>
</View>
  )
}

export default TableHeader